import { all, put, call, race, take, takeLatest } from 'redux-saga/effects'
import * as CurrencyActions from 'Redux/Actions/CurrencyActions'
import * as CurrencyTypes from 'Redux/Types/CurrencyTypes'
import * as ExpenseCategoryActions from 'Redux/Actions/ExpenseCategoryActions'
import * as ExpenseCategoryTypes from 'Redux/Types/ExpenseCategoryTypes'
import * as GLCodeActions from 'Redux/Actions/GLCodeActions'
import * as GLCodeTypes from 'Redux/Types/GLCodeTypes'
import * as GlobalActions from 'Redux/Actions/GlobalActions'
import * as GlobalTypes from 'Redux/Types/GlobalTypes'
import * as JobCodeActions from 'Redux/Actions/JobCodeActions'
import * as JobCodeTypes from 'Redux/Types/JobCodeTypes'
import * as PaymentMethodActions from 'Redux/Actions/PaymentMethodActions'
import * as PaymentMethodTypes from 'Redux/Types/PaymentMethodTypes'
import * as TagActions from 'Redux/Actions/TagActions'
import * as TagTypes from 'Redux/Types/TagTypes'
import * as VendorActions from 'Redux/Actions/VendorActions'
import * as VendorTypes from 'Redux/Types/VendorTypes'
import * as WorkFlowStatusesActions from 'Redux/Actions/WorkFlowStatusesActions'
import * as WorkFlowStatusesTypes from 'Redux/Types/WorkFlowStatusesTypes'
import * as PropertyNameTypes from 'Redux/Types/PropertyNameTypes'
import * as UnitNoTypes from 'Redux/Types/UnitNoTypes'
import * as DepartmentTypes from 'Redux/Types/DepartmentTypes'
import * as DepartmentActions from 'Redux/Actions/DepartmentActions'

import {
  getUserSessionTokenFailed,
  getUserSessionTokenSucceeded,
} from 'Redux/Actions/GlobalActions'

import { GET_USER_SESSION_TOKEN } from 'Redux/Types/GlobalTypes'

import localStorage from 'Service/localStorage'
import { PropertyNameActions, UnitNoActions } from 'Redux/Actions'

function* getUserSessionToken() {
  try {
    const authToken = localStorage.getItem('authToken')
    const authTokenExpirationDate = localStorage.getItem('authTokenExpirationDate')
    yield put(getUserSessionTokenSucceeded({ authToken, authTokenExpirationDate }))
  } catch (error) {
    yield put(getUserSessionTokenFailed(error))
  }
}

function* fetchCurrencies() {
  yield put(CurrencyActions.getCurrencies())

  const [, error] = yield race([
    take(CurrencyTypes.GET_CURRENCIES_SUCCEEDED),
    take(CurrencyTypes.GET_CURRENCIES_FAILED),
  ])

  if (error) {
    throw error
  }
}

function* fetchExpenseCategories() {
  yield put(ExpenseCategoryActions.getExpenseCategories())

  const [, error] = yield race([
    take(ExpenseCategoryTypes.GET_EXPENSE_CATEGORIES_SUCCEEDED),
    take(ExpenseCategoryTypes.GET_EXPENSE_CATEGORIES_FAILED),
  ])

  if (error) {
    throw error
  }
}

function* fetchWorkflowStatuses() {
  yield put(WorkFlowStatusesActions.getWorkFlowStatuses())

  const [, error] = yield race([
    take(WorkFlowStatusesTypes.GET_EXPENSE_WORKFLOW_STATUSES_SUCCEEDED),
    take(WorkFlowStatusesTypes.GET_EXPENSE_WORKFLOW_STATUSES_FAILED),
  ])

  if (error) {
    throw error
  }
}

function* fetchGLCodes() {
  yield put(GLCodeActions.getGLCodes())

  const [, error] = yield race([
    take(GLCodeTypes.GET_GL_CODES_SUCCEEDED),
    take(GLCodeTypes.GET_GL_CODES_FAILED),
  ])

  if (error) {
    throw error
  }
}

function* fetchVendorAliases() {
  yield put(VendorActions.fetchVendorAliases())

  const [, error] = yield race([
    take(VendorTypes.FETCH_VENDOR_ALIASES_SUCCEEDED),
    take(VendorTypes.FETCH_VENDOR_ALIASES_FAILED),
  ])

  if (error) {
    throw error
  }
}

function* fetchJobCodes() {
  yield put(JobCodeActions.getJobCodes())

  const [, error] = yield race([
    take(JobCodeTypes.GET_JOB_CODES_SUCCEEDED),
    take(JobCodeTypes.GET_JOB_CODES_FAILED),
  ])

  if (error) {
    throw error
  }
}

function* fetchTags() {
  yield put(TagActions.getTags())

  const [, error] = yield race([take(TagTypes.GET_TAGS_SUCCEEDED), take(TagTypes.GET_TAGS_FAILED)])

  if (error) {
    throw error
  }
}

function* fetchPaymentMethods() {
  yield put(PaymentMethodActions.getPaymentMethods())

  const [, error] = yield race([
    take(PaymentMethodTypes.GET_PAYMENT_METHODS_SUCCEEDED),
    take(PaymentMethodTypes.GET_PAYMENT_METHODS_FAILED),
  ])

  if (error) {
    throw error
  }
}

function* fetchPropertyNames() {
  yield put(PropertyNameActions.getPropertyNames())

  const [, error] = yield race([
    take(PropertyNameTypes.GET_PROPERTY_NAMES_SUCCEEDED),
    take(PropertyNameTypes.GET_PROPERTY_NAMES_FAILED),
  ])

  if (error) {
    throw error
  }
}

function* fetchUnitNumbers() {
  yield put(UnitNoActions.getUnitNumbers())

  const [, error] = yield race([
    take(UnitNoTypes.GET_UNIT_NUMBERS_SUCCEEDED),
    take(UnitNoTypes.GET_UNIT_NUMBERS_FAILED),
  ])

  if (error) {
    throw error
  }
}

function* fetchDepartments() {
  yield put(DepartmentActions.getDepartments())

  const [, error] = yield race([
    take(DepartmentTypes.GET_DEPARTMENTS_SUCCEEDED),
    take(DepartmentTypes.GET_DEPARTMENTS_FAILED),
  ])

  if (error) {
    throw error
  }
}

function* getTagMappings() {
  yield put(TagActions.getTagMappings())

  const [, error] = yield race([
    take(TagTypes.GET_TAG_MAPPINGS_SUCCEEDED),
    take(TagTypes.GET_TAG_MAPPINGS_FAILED),
  ])

  if (error) {
    throw error
  }
}

function* fetchUserFinancialData() {
  try {
    yield all([
      call(fetchCurrencies),
      call(fetchExpenseCategories),
      call(fetchGLCodes),
      call(fetchJobCodes),
      call(fetchPaymentMethods),
      call(fetchTags),
      call(fetchVendorAliases),
      call(fetchWorkflowStatuses),
      call(fetchPropertyNames),
      call(fetchUnitNumbers),
      call(fetchDepartments),
      call(getTagMappings),
    ])

    yield put(GlobalActions.fetchUserFinancialDataSuccess())
  } catch (error) {
    yield put(GlobalActions.fetchUserFinancialDataFailed(error))
  }
}

export default function* GlobalSaga() {
  yield takeLatest(GET_USER_SESSION_TOKEN, getUserSessionToken)
  yield takeLatest(GlobalTypes.FETCH_USER_FINANCIAL_DATA, fetchUserFinancialData)
}
